module.exports = __webpack_public_path__ + "img/102.4fd6b012.jpg";